import $ from 'jquery'

export function validateTextArea(textAreaInput) {
    $(textAreaInput).find('u, font, span, div, h1, h2, h3, h4, h5, h6, a, img, table, tr, td, th, thead, tbody').each(function() {
        $(this).replaceWith($(this).contents());
    });

    $(textAreaInput).find('*').each(function() {
        this.removeAttribute('style');
        this.className = '';
    });

    return $(textAreaInput).html();
}

export function onPasteSanitize(e) {
    let bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');

    e.preventDefault();

    setTimeout(function() {
        let sanitized = bufferText
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/\r\n|\r|\n/g, '<br>');

        document.execCommand('insertHTML', false, sanitized);
    }, 10);
}
